import React, { useEffect, useState, lazy } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRightIcon, CreditCardIcon, LockIcon } from 'lucide-react';
export const Checkout = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    cardNumber: '',
    cardExpiry: '',
    cardCvc: ''
  });
  useEffect(() => {
    // Redirect to external checkout immediately
    window.location.href = 'https://get.myhealthbeam.com/Clearnail/secure_checkout-1756400194976332-1756406025480233-1756493523952959';
  }, []);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Redirect to external checkout
    window.location.href = 'https://get.myhealthbeam.com/Clearnail/secure_checkout-1756400194976332-1756406025480233-1756493523952959';
  };
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-149">
      <Header data-id="element-150" />
      <main className="flex-grow" data-id="element-151">
        <div className="container mx-auto px-4 py-6" data-id="element-152">
          <div className="mb-4" data-id="element-153">
            <Link to="/pdp" className="text-[#0D9488] text-sm hover:underline" data-id="element-154">
              &larr; Terug naar Product
            </Link>
          </div>
          <h1 className="text-2xl font-bold mb-6" data-id="element-155">Afrekenen</h1>
          <div className="md:flex md:space-x-6" data-id="element-156">
            {/* Checkout Form */}
            <div className="md:w-2/3 mb-6 md:mb-0" data-id="element-157">
              <form onSubmit={handleSubmit} data-id="element-158">
                {/* Contact Information */}
                <div className="bg-white p-6 rounded-lg shadow-sm mb-6" data-id="element-159">
                  <h2 className="text-lg font-semibold mb-4" data-id="element-160">
                    Contactinformatie
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-161">
                    <div data-id="element-162">
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-163">
                        Voornaam
                      </label>
                      <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded" required data-id="element-164" />
                    </div>
                    <div data-id="element-165">
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-166">
                        Achternaam
                      </label>
                      <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded" required data-id="element-167" />
                    </div>
                    <div className="md:col-span-2" data-id="element-168">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-169">
                        E-mailadres
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded" required data-id="element-170" />
                    </div>
                  </div>
                </div>
                {/* Shipping Information */}
                <div className="bg-white p-6 rounded-lg shadow-sm mb-6" data-id="element-171">
                  <h2 className="text-lg font-semibold mb-4" data-id="element-172">Verzendadres</h2>
                  <div className="grid grid-cols-1 gap-4" data-id="element-173">
                    <div data-id="element-174">
                      <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-175">
                        Straat en Huisnummer
                      </label>
                      <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded" required data-id="element-176" />
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-177">
                      <div className="col-span-2 md:col-span-1" data-id="element-178">
                        <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-179">
                          Plaats
                        </label>
                        <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded" required data-id="element-180" />
                      </div>
                      <div data-id="element-181">
                        <label htmlFor="state" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-182">
                          Provincie
                        </label>
                        <input type="text" id="state" name="state" value={formData.state} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded" required data-id="element-183" />
                      </div>
                      <div data-id="element-184">
                        <label htmlFor="zipCode" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-185">
                          Postcode
                        </label>
                        <input type="text" id="zipCode" name="zipCode" value={formData.zipCode} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded" required data-id="element-186" />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Payment Information */}
                <div className="bg-white p-6 rounded-lg shadow-sm mb-6" data-id="element-187">
                  <h2 className="text-lg font-semibold mb-4" data-id="element-188">Betaalgegevens</h2>
                  <div className="grid grid-cols-1 gap-4" data-id="element-189">
                    <div data-id="element-190">
                      <label htmlFor="cardNumber" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-191">
                        Kaartnummer
                      </label>
                      <div className="relative" data-id="element-192">
                        <input type="text" id="cardNumber" name="cardNumber" value={formData.cardNumber} onChange={handleChange} placeholder="1234 5678 9012 3456" className="w-full p-2 border border-gray-300 rounded pl-10" required data-id="element-193" />
                        <CreditCardIcon size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-194" />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4" data-id="element-195">
                      <div data-id="element-196">
                        <label htmlFor="cardExpiry" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-197">
                          Vervaldatum
                        </label>
                        <input type="text" id="cardExpiry" name="cardExpiry" value={formData.cardExpiry} onChange={handleChange} placeholder="MM/JJ" className="w-full p-2 border border-gray-300 rounded" required data-id="element-198" />
                      </div>
                      <div data-id="element-199">
                        <label htmlFor="cardCvc" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-200">
                          CVC
                        </label>
                        <input type="text" id="cardCvc" name="cardCvc" value={formData.cardCvc} onChange={handleChange} placeholder="123" className="w-full p-2 border border-gray-300 rounded" required data-id="element-201" />
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center mt-4 text-sm text-gray-600" data-id="element-202">
                    <LockIcon size={14} className="mr-1" data-id="element-203" />
                    <span data-id="element-204">
                      Je betaalgegevens zijn beveiligd met SSL-encryptie
                    </span>
                  </div>
                </div>
                <button type="submit" className="w-full bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors flex items-center justify-center" data-id="element-205">
                  Bestelling Afronden
                  <ChevronRightIcon size={18} className="ml-1" data-id="element-206" />
                </button>
              </form>
            </div>
            {/* Order Summary */}
            <div className="md:w-1/3" data-id="element-207">
              <div className="bg-white p-6 rounded-lg shadow-sm sticky top-20" data-id="element-208">
                <h2 className="text-lg font-semibold mb-4" data-id="element-209">Besteloverzicht</h2>
                <div className="border-b pb-4 mb-4" data-id="element-210">
                  <div className="flex items-start mb-4" data-id="element-211">
                    <img src="https://images.unsplash.com/photo-1585914641050-fa9883c4e21c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2067&q=80" alt="ClearNail pleister die op teennagel wordt aangebracht" className="w-16 h-16 object-cover rounded mr-3" loading="lazy" width="64" height="64" data-id="element-212" />
                    <div data-id="element-213">
                      <h3 className="font-medium" data-id="element-214">
                        ClearNail Schimmelbehandeling
                      </h3>
                      <p className="text-sm text-gray-600" data-id="element-215">Aantal: 1</p>
                      <p className="text-[#0D9488] font-medium" data-id="element-216">$49.99</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between text-sm mb-2" data-id="element-217">
                    <span className="text-gray-600" data-id="element-218">Gratis Welzijnsgids</span>
                    <span className="text-gray-600" data-id="element-219">$0.00</span>
                  </div>
                </div>
                <div className="mb-4" data-id="element-220">
                  <div className="flex items-center justify-between mb-2" data-id="element-221">
                    <span className="text-gray-600" data-id="element-222">Subtotaal</span>
                    <span data-id="element-223">$49.99</span>
                  </div>
                  <div className="flex items-center justify-between mb-2" data-id="element-224">
                    <span className="text-gray-600" data-id="element-225">Verzending</span>
                    <span data-id="element-226">Gratis</span>
                  </div>
                  <div className="flex items-center justify-between mb-2" data-id="element-227">
                    <span className="text-gray-600" data-id="element-228">Btw</span>
                    <span data-id="element-229">$4.00</span>
                  </div>
                </div>
                <div className="flex items-center justify-between font-bold text-lg border-t pt-4" data-id="element-230">
                  <span data-id="element-231">Totaal</span>
                  <span data-id="element-232">$53.99</span>
                </div>
                <div className="mt-6" data-id="element-233">
                  <div className="relative" data-id="element-234">
                    <input type="text" placeholder="Kortingscode" className="w-full p-2 pr-20 border border-gray-300 rounded" data-id="element-235" />
                    <button className="absolute right-0 top-0 bottom-0 bg-gray-200 px-3 text-sm font-medium rounded-r" data-id="element-236">
                      Toepassen
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-237" />
    </div>;
};